import React, { useEffect } from "react";
import { Snackbar, Alert, AlertColor } from "@mui/material";
import { useNetworkStatus } from "../../hooks/useNetworkStatus";
import { useTranslation } from "react-i18next";

const NetworkStatusNotification: React.FC = () => {
  const { isOnline, wasOffline, wasOnline } = useNetworkStatus();
  const { t } = useTranslation();
  const [open, setOpen] = React.useState(false);
  const [message, setMessage] = React.useState("");
  const [severity, setSeverity] = React.useState<AlertColor>("info");

  useEffect(() => {
    if (wasOffline) {
      setMessage(t("network.offline") || "Нет подключения к интернету");
      setSeverity("warning");
      setOpen(true);
    } else if (wasOnline && !isOnline) {
      return;
    } else if (wasOnline) {
      setMessage(t("network.online") || "Подключение к интернету восстановлено");
      setSeverity("success");
      setOpen(true);
    }
  }, [wasOffline, wasOnline, isOnline, t]);

  const handleClose = (
    event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  if (!wasOffline && !wasOnline) {
    return null;
  }

  return (
    <Snackbar
      open={open}
      autoHideDuration={wasOffline ? null : 4000}
      onClose={handleClose}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      sx={{ mt: 8 }}
    >
      <Alert
        onClose={handleClose}
        severity={severity}
        variant="filled"
        sx={{ width: "100%" }}
        icon={isOnline ? undefined : null}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

export default NetworkStatusNotification;

